export default "__VITE_ASSET__D_ax_m03__"